import "./account-avatar.scss";
import { ButtonIcon } from "../../../../components/inputs/button-icon/button-icon";
import IconEdit from "../../../../components/icons/icon-edit/icon-edit";
import AccountEditorStore from "../../stores/account-editor-store";
import avatar_empty from '../../../../images/avatar_empty.svg';
import { observer } from "mobx-react";

export enum AVATAR_VARIANT {
    SMALL = 'small',
    BIG = 'big',
}


interface IProps {
    account?: AccountEditorStore;
    editable?: boolean;
    variant?: AVATAR_VARIANT;
}

const AccountAvatar: React.FC<IProps> = observer(({
    account,
    editable = false,
    variant = AVATAR_VARIANT.SMALL,
}) => {
    const avatarSrc = () => {
        if (account?.avatar_url) {
            return account.avatar_url;
        }
        return avatar_empty;
    }

    const showImage = (): boolean => {
        const hasInitials = account?.getInitials() !== undefined;
        const hasAvatar = !!account?.avatar_url;
        return hasAvatar || !hasInitials;
    }

    return (
        <div className={`account-avatar ${variant}`}>
            {editable && <ButtonIcon Component={() => <IconEdit color={'var(--color-neutral-1-white)'} />} />}
            <div className="account-avatar-placeholder">
                {account && 
                    <>                    
                        {!showImage() &&
                            account.getInitials()
                        }
                        {showImage() &&
                            <img src={avatarSrc()} alt="avatar" />
                        }
                    </>
                }
            </div>
        </div>
    );
});

export default AccountAvatar;
